export default {"src":"/_next/static/media/fortress.621731e8.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};